import React from 'react';
import { get } from 'lodash-es';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getModelState } from 'client/data/luckdragon/model';
import { handle404Error } from 'site-modules/shared/utils/errors';
import { parseContent } from 'client/data/cms/content';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { getMeta } from 'site-modules/shared/utils/seo-helper';
import { CmsModel } from 'client/data/models/cms';
import { buildGlossaryTermBreadcrumbs, buildGlossaryTermContentPath } from 'site-modules/glossary/utils/glossary';
import { GlossaryTerm } from './glossary-term';

export const pageOptions = {
  name: 'other_glossary_index',
  category: 'other',
  preload: (store, props) => {
    const { term } = props.match.params;
    const preloader = new ModelPreloader(store);

    preloader.resolve(`content["${buildGlossaryTermContentPath(term)}.withContent"]`, CmsModel);

    return preloader.load().then(modelState => {
      const content = modelState.get(`content["${buildGlossaryTermContentPath(term)}.withContent"]`, CmsModel);

      if (!get(content, 'title')) {
        throw handle404Error({ errorMessage: `No glossary content for ${term}` });
      }

      return preloader.load();
    });
  },
  seo: (state, props) => {
    const { term } = props.match.params;
    const modelState = getModelState(state);
    const content = parseContent(
      modelState.get(`content["${buildGlossaryTermContentPath(term)}.withContent"]`, CmsModel)
    );
    const title = content
      .child('sub-page-1')
      .child('sub-page-1-left-col')
      .child('editorial-header')
      .metadata('title')
      .value();

    return {
      ...getMeta(content),
      jsonld: [getBreadcrumbSchema(buildGlossaryTermBreadcrumbs(title, term))],
    };
  },
  component: props => <GlossaryTerm term={get(props, 'match.params.term')} />,
};

export default pageDefinition(pageOptions);
